/**
 * Main JavaScript Entry Point
 * This file imports all JavaScript modules and SCSS
 */

// Import SCSS first so it's bundled with the JS
import "../scss/main.scss";

// Import utils FIRST - it contains the passive event listener patch for jQuery
import "./utils.js";

// Initialize error boundary
import "./error-handler.js";

// Import all other modules
import "./animations.js";
import "./header.js";
import "./blog.js";
import "./accordion.js";
import "./slider.js";
import "./misc.js";
import "./web-vitals.js";

// Import and initialize Web Vitals tracking (with error handling)
// Using dynamic import wrapped in an async function to avoid top-level await
(async () => {
  try {
    const { initWebVitals } = await import("./web-vitals.js");
    if (initWebVitals) {
      initWebVitals();
    }
  } catch (error) {
    console.warn("Web Vitals not available:", error);
  }
})();
